import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {useFetch} from '../hooks/useFetch';
import {useState} from 'react';
import useHandleErrors from '../hooks/useHandleErrors';

export default ({onChange, name, value = [], ...props}) => {
    const [errs, setErrs] = useState();
    useHandleErrors(errs);

    const {data, isLoading, mutate} = useFetch('/backoffice/topics');

    const options = data?.map(item => ({label: item.name, id: item.id})) || [];

    const handleSelect = (e, data) => {
        onChange(name, data.map(item => Number(item.id)) || []);
    };

    const selectedCategories = options.filter(item => value.includes(item.id));

    return (
        <>
            <Autocomplete
                options={options}
                onChange={handleSelect}
                value={selectedCategories}
                getOptionLabel={({label}) => label}
                //size={2}
                limitTags={2}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                loading={isLoading}
                filterSelectedOptions
                id="select-topics"
                fullWidth
                multiple
                {...props}
                renderInput={params => <TextField {...params} label="Tópicos" />}
            />
        </>
    );
};
